import { NavLink } from 'react-router-dom';
import AppDownloadBanner from './AppDownloadBanner';
import './Sidebar.css';

interface NavItem {
  path: string;
  label: string;
  icon: string;
}

const NAV_ITEMS: NavItem[] = [
  { path: '/', label: '대시보드', icon: '🏠' },
  { path: '/analytics', label: '운영 분석', icon: '📊' },
  { path: '/billing', label: '플랜 & 급여', icon: '💳' },
  { path: '/chat', label: '오팀장 채팅', icon: '💬' },
];

export default function Sidebar() {
  return (
    <aside className="sidebar">
      {/* 로고 */}
      <div className="sidebar__logo">
        <span className="sidebar__logo-icon">🤖</span>
        <div className="sidebar__logo-text">
          <span className="sidebar__logo-name">오팀장</span>
          <span className="sidebar__logo-sub">AI 쇼핑몰 운영팀</span>
        </div>
      </div>

      {/* 네비게이션 */}
      <nav className="sidebar__nav">
        <ul className="sidebar__nav-list">
          {NAV_ITEMS.map(({ path, label, icon }) => (
            <li key={path}>
              <NavLink
                to={path}
                end={path === '/'}
                className={({ isActive }) =>
                  `sidebar__nav-item ${isActive ? 'active' : ''}`
                }
              >
                <span className="sidebar__nav-icon">{icon}</span>
                <span className="sidebar__nav-label">{label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      {/* 앱 다운로드 배너 */}
      <AppDownloadBanner />

      {/* 하단 영역 */}
      <div className="sidebar__footer">
        <div className="sidebar__footer-text">
          <span>© 2026 수파레인</span>
        </div>
      </div>
    </aside>
  );
}
